<template>
    <div v-if="marker !== null"
         style="flex: 1 1 0; margin-bottom: 30px"
         class="mt-2">
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>
        <l-map style="height: 350px; border-top-right-radius: 8px; border-top-left-radius: 8px; z-index: 1"
               :zoom="16"
               :options="{
                            dragging: false,
                            zoomControl: false,
                            doubleClickZoom: false
                       }"
               :center="marker">
            <l-tile-layer
              :url="url"
              :attribution="attribution"/>
            <l-marker :lat-lng="marker"></l-marker>
        </l-map>
        <div class="map-footer d-flex justify-content-between sm-flex-column">
            <div class="mt-auto mb-auto">
                <div class="d-flex" v-if="provider.localisation.latitude === null">
                    <v-icon color="warning" class="mr-2">warning</v-icon>
                    <p class="mb-2 mt-2" style="color: white">Vos coordonnées GPS ne sont pas exactes</p>
                </div>
            </div>
            <v-btn :style="'background-color:' + primaryColor + '!important'"
                   class="default-button text-none mt-auto mb-auto" @click="openGpsModal">Modifier l'emplacement
            </v-btn>
        </div>

        <v-dialog v-model="gpsModal"
                  persistent
                  fullscreen
                  content-class="pro-full-screen-dialog"
                  hide-overlay
                  transition="dialog-bottom-transition">
            <v-toolbar dark color="primary">
                <v-toolbar-title>Modification de vos coordonnées GPS</v-toolbar-title>
            </v-toolbar>

            <div style="height: calc(100% - 64px); background-color: white">
                <div style="height: calc(100% - 68px)">
                    <l-map
                      style="height: 100%; width: 100%; border-top-right-radius: 8px; border-top-left-radius: 8px; z-index: 1"
                      :zoom="16"
                      v-if="loadedModal"
                      :center="marker">
                        <l-tile-layer
                          :url="url"
                          :attribution="attribution"/>
                        <l-marker :lat-lng="marker" draggable @dragend="updateLatLng"></l-marker>
                    </l-map>
                </div>

                <div class="p-3" style="background-color: #414a65">
                    <div class="d-none d-sm-flex justify-content-between">
                        <div class="d-flex">
                            <v-btn class="default-button mr-3" color="error" @click="cancelUpdateGps">Annuler</v-btn>
                            <v-btn style="color: white" :color="primaryColor" @click="resetGps">Réinitialiser</v-btn>
                        </div>

                        <div class="mt-auto mb-auto ml-2 mr-2" style="color: white">
                            Cliquez et restez appuyé sur l'icône au centre de la carte pour le déplacer sur votre
                            établissement.
                        </div>

                        <v-btn style="color: white" :color="primaryColor" @click="gpsModal = false">Valider</v-btn>
                    </div>
                    <div class="d-md-none d-flex justify-content-between">
                        <div class="d-flex">
                            <v-icon color="error" large @click="cancelUpdateGps">cancel</v-icon>
                            <v-icon :color="primaryColor" large class="ml-5 mr-5" @click="resetGps">restart_alt</v-icon>
                        </div>

                        <v-icon :color="primaryColor" large class="ml-5" @click="gpsModal = false">save</v-icon>
                    </div>

                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import {fieldsMapping} from "../../../../static/webform"
import {latLng} from "leaflet"
import HelpTooltip from "../../../tools/HelpTooltip.vue";

export default {
    name: "FormGeo",
    components: {HelpTooltip},
    props: ['field'],
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            marker: null,
            tmpMarker: null,
            originalMarker: null,
            cityGps: false,
            gpsModal: false,
            loadedModal: false
        }
    },
    methods: {
        openGpsModal() {
            this.tmpMarker = JSON.parse(JSON.stringify(this.marker))
            this.gpsModal = true

            setTimeout(() => {
                this.loadedModal = true
            }, 300)
        },
        updateLatLng(event) {
            let marker = event.target
            let latLng = marker.getLatLng()

            this.provider.localisation.latitude = latLng.lat
            this.provider.localisation.longitude = latLng.lng

            this.marker = latLng
        },
        resetGps() {
            this.marker = this.originalMarker

            if (!this.cityGps) {
                // reset la valeur de base des lat/lng du provider
                this.provider.localisation.latitude = this.marker.lat
                this.provider.localisation.longitude = this.marker.lng
            } else {
                // si on a des coordonnees de la commune c'est que celle de la localisation étaient nulle à la base
                this.provider.localisation.latitude = null
                this.provider.localisation.longitude = null
            }
        },
        setMarker() {
            if (this.provider.localisation !== null && this.provider.localisation !== undefined) {
                if (this.provider.localisation.latitude !== null && this.provider.localisation.latitude !== undefined) {
                    this.marker = latLng(this.provider.localisation.latitude, this.provider.localisation.longitude)
                } else if (this.provider.localisation.commune !== undefined) {
                    this.marker = latLng(this.provider.localisation.commune.latitude, this.provider.localisation.commune.longitude)
                    this.cityGps = true
                }

                this.originalMarker = JSON.parse(JSON.stringify(this.marker))
            }
        },
        cancelUpdateGps() {
            this.marker = this.tmpMarker
            this.gpsModal = false
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", 'primaryColor']),
        ...mapState("web_form", ['submitted', 'provider'])
    },
    mounted() {
        this.setMarker()
    }
}
</script>